import { defaultNotificationOptionsSettingValue } from '../../../../../../../backend/config/settings/NotificationOptionsDefaultValue';
import { useAlertConfig, useAlertUiTranslation } from '../../../../../../hooks';
import { useFormRow } from '../../Components/useFormRow';
export function useDeliveryOrderPanel(config) {
    const { t } = useAlertUiTranslation();
    const { notificationOptions } = useAlertConfig();
    const escalationTextValues = notificationOptions && (notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions.escalationOptions)
        ? notificationOptions.escalationOptions.textValues
        : defaultNotificationOptionsSettingValue.escalationOptions.textValues;
    const escalationVoiceValues = notificationOptions && (notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions.escalationOptions)
        ? notificationOptions.escalationOptions.voiceValues
        : defaultNotificationOptionsSettingValue.escalationOptions.voiceValues;
    return {
        type: 'form.panel',
        style: {
            layout: 'column',
            paddingTop: config === null || config === void 0 ? void 0 : config.paddingTop,
            horizontalAlign: 'left',
            surface: 'level1',
        },
        children: [
            useFormRow([
                {
                    type: 'form.content',
                    key: 'content',
                    template: {
                        data: '',
                        content: `<div style="display: flex; align-items: center"> <span class="icon-send-time-extension-outlined grey-700"></span> <p style="font-size: 20px; padding-left: 16px" class="subtitle1"> ${t('wizard.defineDelivery.deliveryOrder')}</p></div>`,
                    },
                },
                {
                    type: 'alert.deliveryOrder',
                    key: 'deliveryOrder',
                    defaultEscalationTextValue: notificationOptions && (notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions.escalationOptions)
                        ? notificationOptions.escalationOptions.textDefault
                        : defaultNotificationOptionsSettingValue.escalationOptions.textDefault,
                    defaultEscalationVoiceValue: notificationOptions && (notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions.escalationOptions)
                        ? notificationOptions.escalationOptions.voiceDefault
                        : defaultNotificationOptionsSettingValue.escalationOptions.voiceDefault,
                    escalationTextValues: getEscalationValues(escalationTextValues, t),
                    escalationVoiceValues: getEscalationValues(escalationVoiceValues, t),
                    style: {
                        paddingLeft: config.mode === 'edit' ? 56 : 49,
                    },
                },
            ], config.mode),
        ],
    };
}
const getEscalationValues = (values, t) => {
    return values.map((value) => ({ label: t('common.minutes', { minutes: value }), value: value }));
};
